import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_cd9eh4b3jg: FaireCollectionEntity = {
  token: "pbc_cd9eh4b3jg",
  type: "collection",
  name: "gift tags",
  heroImageUrl:
    "https://cdn.faire.com/fastly/add196f729430712bed41ea52fddfc8233264696cced18b4d7919b18f0f75c78.jpeg",
  itemCount: 6,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:23.623Z",
    importedBy: "entity-db-import-collections",
  },
};
